import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './New.css';

const New = ({ onClose, onAddRecord, initialData }) => {
  const [formData, setFormData] = useState(
    initialData || {
      name: '',
      date: '',
      eating: '',
      workingOut: '',
      walking: '',
      alcohol: '',
      supplements: '',
      meditation: '',
      hydration: ''
    }
  );
  const [showError, setShowError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.name === 'name' ? e.target.value : Number(e.target.value)
    });
    setShowError(false); // Clear error when user makes changes
  };

  const handleDateChange = (date) => {
    setFormData({
      ...formData,
      date: date ? date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }) : ''
    });
    setShowError(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Check if any field is empty
    if (Object.values(formData).some(value => value === '')) {
      setShowError(true);
      return;
    }

    setIsSubmitting(true);

    // Calculate total points and bonus
    const maxPossiblePoints = {
      eating: 10,
      workingOut: 10,
      walking: 10,
      alcohol: 10,
      supplements: 10,
      meditation: 10,
      hydration: 5
    };

    const currentPoints = Object.entries(maxPossiblePoints).reduce((total, [key, maxValue]) => {
      return total + Number(formData[key]);
    }, 0);

    const totalPossiblePoints = Object.values(maxPossiblePoints).reduce((a, b) => a + b, 0);
    
    // Add bonus field to submission data
    const submissionData = {
      ...formData,
      bonus: currentPoints === totalPossiblePoints ? 10 : 0
    };

    console.log(submissionData);

    try {
      const response = await fetch('https://prryj10q5a.execute-api.us-east-1.amazonaws.com/api/add-record', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },  
        body: JSON.stringify(submissionData)
      });
      const data = await response.json();
      console.log(data);
      
      if (response.ok) {
        // Add the new record to the state in App.js
        onAddRecord(submissionData);
        
        // Clear form and close popup on successful submission
        setFormData({
          name: '',
          date: '',
          eating: '',
          workingOut: '',
          walking: '',
          alcohol: '',
          supplements: '',
          meditation: '',
          hydration: ''
        });
        onClose(); // Close the popup
      } else {
        alert('Error adding record. Please try again.');
      }
    } catch (error) {
      console.error('Error adding record:', error);
      alert('Error adding record. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>
        <h2>Add Record</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>NAME</label>
            <select name="name" value={formData.name} onChange={handleChange}>
              <option value="">Select...</option>
              <option value="Pops">Pops</option>
              <option value="Tan Tan">Tan Tan</option>
              <option value="Kylieee">Kylieee</option>
              <option value="Paulina">Paulina</option>
              <option value="Mai">Mai</option>
              <option value="Evan">Evan</option>
              <option value="Steph">Steph</option>
              <option value="Ryan">Ryan</option>
            </select>
          </div>
          <div className="form-group">
            <label>DATE</label>
            <DatePicker
              selected={formData.date ? new Date(formData.date) : null}
              onChange={handleDateChange}
              dateFormat="yyyy-MM-dd"
              placeholderText="Select a date"
              className="date-picker"
              minDate={new Date('2025-03-10')}
              maxDate={new Date('2025-05-31')}
            />
          </div>
          <div className="form-group">
            <label>1. Eating (max 10 pts)</label>
            <p className="quote-text"><i>"You are what you eat!"</i></p>
            <select name="eating" value={formData.eating} onChange={handleChange}>
              <option value="">Select...</option>
              <option value="10">Healthy daily diet (10 pts)</option>
              <option value="5">Mostly healthy with small indulgence (5 pts)</option>
              <option value="0">Unhealthy portions/diet (0 pts)</option>
            </select>
          </div>

          <div className="form-group">
            <label>2. Working Out (max 10 pts)</label>
            <p className="quote-text"><i>"Is like a relationship, if you cheat it won't work!"</i></p>
            <select name="workingOut" value={formData.workingOut} onChange={handleChange}>
              <option value="">Select...</option>
              <option value="10">30+ minutes workout (10 pts)</option>
              <option value="5">14-30 minutes (5 pts)</option>
              <option value="0">None (0 pts)</option>
            </select>
          </div>

          <div className="form-group">
            <label>3. Walking (max 10 pts)</label>
            <p className="quote-text"><i>"The old man version of running."</i></p>
            <select name="walking" value={formData.walking} onChange={handleChange}>
              <option value="">Select...</option>
              <option value="10">4+ miles daily (10 pts)</option>
              <option value="5">2-4 miles (5 pts)</option>
              <option value="0">Less than 2 miles (0 pts)</option>
            </select>
          </div>

          <div className="form-group">
            <label>4. Alcohol (max 10 pts)</label>
            <p className="quote-text"><i>"Drinking is bad but somehow the more I drink the less bad it feels."</i></p>
            <select name="alcohol" value={formData.alcohol} onChange={handleChange}>
              <option value="">Select...</option>
              <option value="10">None (10 pts)</option>
              <option value="5">1-2 drinks (5 pts)</option>
              <option value="0">More than 2 drinks (0 pts)</option>
            </select>
          </div>

          <div className="form-group">
            <label>5. Supplements (max 10 pts)</label>
            <p className="quote-text"><i>"The easiest way to make a difference without effort."</i></p>
            <select name="supplements" value={formData.supplements} onChange={handleChange}>
              <option value="">Select...</option>
              <option value="10">All essential supplements (10 pts)</option>
              <option value="5">Some supplements (5 pts)</option>
              <option value="0">None (0 pts)</option>
            </select>
          </div>

          <div className="form-group">
            <label>6. Mental Well-Being (max 10 pts)</label>
            <p className="quote-text"><i>"It all starts with the mind!"</i></p>
            <select name="meditation" value={formData.meditation} onChange={handleChange}>
              <option value="">Select...</option>
              <option value="10">15+ mins meditation/yoga (10 pts)</option>
              <option value="5">5-15 mins meditation/yoga (5 pts)</option>
              <option value="0">No meditation or yoga (0 pts)</option>
            </select>
          </div>

          <div className="form-group">
            <label>7. Hydration (max 5 pts)</label>
            <p className="quote-text"><i>"Drink at least 2 liters of water."</i></p>
            <select name="hydration" value={formData.hydration} onChange={handleChange}>
              <option value="">Select...</option>
              <option value="5">2+ liters of water (5 pts)</option>
              <option value="0">Less than 2 liters (0 pts)</option>
            </select>
          </div>

          <div className="form-group">
            <label>Bonus</label>
            <p className="bonus-text">10 bonus points will be awarded for achieving maximum points in all categories!</p>
          </div>

          {showError && (
            <div className="error-message">
              Please fill out all fields before submitting
            </div>
          )}
          <button 
            type="submit" 
            className="submit-button" 
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default New;
